<template>
  <v-content class="noPadding">
    <v-fade-transition mode="out-in">
      <router-view />
    </v-fade-transition>
  </v-content>
</template>

<script>
export default {
  metaInfo() {
    return {
      titleTemplate: "%s — Greenfield Custom Meat "
    };
  }
};
</script>

<style>
.noPadding {
  background: #424242;
  padding: 2% !important;
}
</style>

